import { Component, Input, model } from '@angular/core';

@Component({
    selector: 'c-multi-checkbox',
    templateUrl: './multi-checkbox.component.html',
    styleUrl: './multi-checkbox.component.css',
    standalone: false
})
export class MultiCheckboxComponent {
  processData(event: { status: boolean; data: any }) {
    const data = this.option();
    if (data) {
      if (event.status) {
        data.push(event.data);
        this.option.set(data);
      } else {
        const i = data.findIndex((i) =>
          this.id ? i[this.id] == event.data[this.id] : i == event.data
        );
        if (i >= 0) {
          data.splice(i, 1);
          this.option.set(data);
        }
      }
    } else {
      this.option.set([event.data]);
    }
  }

  @Input() options!: any[];
  @Input() itemProperty!: string;
  @Input() id!: string;
  option = model<any[]>([]);

  initProcess(d: any): boolean {
    const data = this.option();
    return data.some((i) => (this.id ? i[this.id] == d[this.id] : i == d));
  }
}
